import AppBar from "@mui/material/AppBar";
import { MenuItem, Select, SelectChangeEvent, Toolbar } from "@mui/material";
import { useTranslation } from "react-i18next";
import englishFlag from "../Assets/Flags/EN.png";
import spanishFlag from "../Assets/Flags/ES.png";
import { useState } from "react";
import MobileNavBar from "./MobileNavBar";
import DesktopNavBar from "./DesktopNavBar";


export default function NavBar() {
  const { i18n } = useTranslation();
  const changeLanguageHandler = (event: SelectChangeEvent) => {
    i18n.changeLanguage(event.target.value as string)
  }
  const [open, setOpen] = useState(false);
  const isMobile = window.innerWidth < 500;


  return (
    <AppBar position= {isMobile ? "sticky" : "static"}>
      <Toolbar disableGutters>
        {isMobile ?
          <MobileNavBar open={open} handleOpen={setOpen} />
          :
          <DesktopNavBar />
        }
        <Select
          id="lang-Selector"
          value={i18n.languages[0].includes("en") ? "en" : "es"}
          onChange={changeLanguageHandler}
          inputProps={{ IconComponent: () => null }}
          sx={{ float: "right", marginLeft: "auto", marginTop: "6px", paddingTop: "4px", boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 } }}>
          <MenuItem value="es"><img width="25" height="25" src={spanishFlag} alt="español" /></MenuItem>
          <MenuItem value="en"><img width="25" height="25" src={englishFlag} alt="english" /></MenuItem>
        </Select>
      </Toolbar>
    </AppBar>
  );
}
